import React from "react";

import { NavLink } from "react-router-dom";
import classes from "./BottomToolBar.module.css";

const vehicleTypes = {
    cars: 'cars',
    motors: 'motors',
    commercials: 'commercials',
    accessories: 'accessories',
    parts: 'parts',
    dealers: 'dealers',
    services: 'services',
    rental: 'rental',
}

const BottomToolBar = (props) => (
    <div style={{
        borderTop: '1px solid #E0E0E0',
        borderBottom: '1px solid #E0E0E0'
    }}>
        <div className={classes.BottomToolBar}>
            <p>Quick Search</p>
            {Object.values(vehicleTypes).map(element => {
                return (
                    <NavLink key={element}
                        to='/Search'
                        onClick={() => { props.changeType(vehicleTypes[`${element}`]) }}
                        onContextMenu={(event) => {
                            event.preventDefault()
                        }}>{element}
                    </NavLink>
                );
            })}
        </div>
    </div>
);

export default BottomToolBar;